// eslint-disable-next-line import/prefer-default-export
export const HE_ROLES = [
  'administrator', 'publishing', 'community',
];
